import { css } from "@emotion/css";

export const linkButtonCss = css`
  appearance: none;
  border: none;
  background: none;
  padding: 0.25rem;
  text-decoration: underline;
  cursor: pointer;
`;
